import React, { useState, useEffect } from 'react'
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tabs,
  Tag
} from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import { CoinType } from '../../../../config'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import UpdateDeviceForm from './components/UpdateDeviceForm'
import UpdateBranchForm from './components/UpdateBranchForm'
import {
  fetchDeviceByHeroId,
  updateDevice,
  deleteDevice,
  fetchBranchByHeroId,
  deleteBranch,
  updateBranch,
  resetLomaData
} from '../../../../modules/loma'
import moment from 'moment'
import Lightbox from 'react-image-lightbox'
import '../../../../../node_modules/react-image-lightbox/style.css'

export const HeroLoma = ({ data }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visibleBranch, setVisibleBranch] = useState(false)
  const [formData, setFormData] = useState({})
  const { device, isLoading, branch } = useSelector(
    (state) => ({
      device: state.loma.device,
      isLoading: state.loma.isLoading,
      branch: state.loma.branch
    }),
    []
  )
  const heroId = data.id

  function fetch() {
    dispatch(fetchDeviceByHeroId(heroId))
    dispatch(fetchBranchByHeroId(heroId))
  }

  useEffect(() => {
    return () => {
      dispatch(resetLomaData())
    }
  }, [])

  useDeepEffect(() => {
    if (!isEmpty(data)) {
      fetch()
    }
  }, [data])

  const onClick = () => {
    setVisible(true)
  }

  const onClickUpdateBranch = () => {
    setVisibleBranch(true)
  }

  const onCloseModal = async () => {
    await fetch()
    await setVisible(false)
  }

  const onCloseBranchModal = async () => {
    await fetch()
    await setVisibleBranch(false)
  }

  const onOk = async (data) => {
    await dispatch(updateDevice(data))
    await fetch()
    await setVisible(false)
    await setFormData({})
  }

  const onOkBranch = async (data) => {
    await dispatch(updateBranch(data))
    await fetch()
    await setVisibleBranch(false)
  }

  const onDelete = async (id) => {
    await dispatch(deleteDevice(heroId, id))
    await fetch()
  }

  const onDeleteBranch = async (id) => {
    await dispatch(deleteBranch(heroId, id))
    await fetch()
  }

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'ชื่อเครื่อง',
      dataIndex: 'deviceName',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'device ID',
      dataIndex: 'device'
    },
    {
      title: 'ชื่อพนักงาน',
      dataIndex: 'deviceUser',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'App Version',
      dataIndex: 'appVersion',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <span>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const columnsBranch = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'ชื่อ',
      dataIndex: 'name',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'address',
      dataIndex: 'address'
    },
    {
      title: 'locationAddress',
      dataIndex: 'locationAddress',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'status',
      dataIndex: 'active',
      render: (text) => (
        <span>
          {text ? (
            <Tag color="green">Active</Tag>
          ) : (
            <Tag color="red">Inactive</Tag>
          )}
        </span>
      )
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <span>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDeleteBranch(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <div>
      <Card>
        {branch && branch.branchResponseList ? (
          <div>
            <div align="right">
              <Tag color="#7b5ef0">LOMA User : {branch.lomaUser}</Tag>
              <Tag color="#3700B3">
                สาขา : {branch.branchResponseList.length} /{' '}
                {branch.branchAvailable}
              </Tag>
              <span>
                <Button
                  size="small"
                  onClick={() => {
                    onClickUpdateBranch()
                  }}>
                  Update Branch Available
                </Button>
              </span>
            </div>
            <br></br>
            <h3>สาขา</h3>
            <Table
              loading={isLoading}
              rowKey={(record) => record.id}
              dataSource={branch.branchResponseList}
              columns={columnsBranch}
            />
            <UpdateBranchForm
              visible={visibleBranch}
              heroId={heroId}
              branch={branch.branchAvailable}
              onOk={onOkBranch}
              onCancel={onCloseBranchModal}
            />
          </div>
        ) : (
          <div align="Center">
            <h3>ฮีโร่ {data.name} ยังไม่ได้เปิดใช้งาน LOMA</h3>
          </div>
        )}
      </Card>
      <Card>
        {device && device.lomaUserDeviceList ? (
          <div>
            <div align="right">
              <Tag color="#7b5ef0">LOMA User : {device.lomaUser}</Tag>
              <Tag color="#3700B3">
                เครื่องที่ใช้งานได้ : {device.lomaUserDeviceList.length} /{' '}
                {device.deviceAvailable}
              </Tag>
              <span>
                <Button
                  size="small"
                  onClick={() => {
                    onClick()
                  }}>
                  Update Device Available
                </Button>
              </span>
            </div>
            <br></br>
            <h3>เครื่องที่ใช้งาน</h3>
            <Table
              loading={isLoading}
              rowKey={(record) => record.id}
              dataSource={device.lomaUserDeviceList}
              columns={columns}
            />
            <UpdateDeviceForm
              visible={visible}
              heroId={heroId}
              device={device.deviceAvailable}
              onOk={onOk}
              onCancel={onCloseModal}
            />
          </div>
        ) : (
          <div align="Center">
            <h3>ฮีโร่ {data.name} ยังไม่ได้เปิดใช้งาน LOMA</h3>
          </div>
        )}
      </Card>
    </div>
  )
}

export default HeroLoma
